import React, { useState } from 'react';
import { connect } from 'react-redux';
import { IonRow } from '@ionic/react';
import { RootState } from '../../models/RootState';
import withdrawal from '../../assets/images/common/icons/withdrawal.png';
import gpay from '../../assets/images/common/icons/gpay.png';
import paytm from '../../assets/images/common/icons/paytm.png';
import phonepay from '../../assets/images/common/icons/phonepay.png';
import TabPanel from '../../components/TabPanel/TabPanel';
import { Tabs, Tab } from '@material-ui/core';
import './Payment.scss';
import Bank from './WithdrawalOptions/Bank';
import GPay from './WithdrawalOptions/GPay';
import Paytm from './WithdrawalOptions/Paytm';
import PhonePay from './WithdrawalOptions/PhonePay';
import { BRAND_NAME } from '../../constants/Branding';
import { WHDetails } from '../../constants/WhitelabelConfig';
type StoreProps = {};

const Withdrawal: React.FC<StoreProps> = (props) => {
  const [tabValue, setTabValue] = useState<number>(0);

  return (
    <div className="reports-ctn payment-ctn">
      <div className="header-ctn my-wallet-header">
        <IonRow>
          <div className="img-page-title-row">
            <img className="title-image" src={withdrawal} />
            <div className="title">Withdrawal</div>
          </div>
        </IonRow>
        <Tabs
          value={tabValue}
          onChange={(_, newValue) => {
            setTabValue(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          className="payment-tabs"
        >
          <Tab className={'back-icon'} label="Bank" value={0} />
          <Tab
            value={1}
            icon={
              <img
                className={'payment-icon'}
                alt="gpay"
                src={gpay}
                loading="lazy"
              />
            }
          />

          <Tab
            value={3}
            icon={
              <img
                className={'payment-icon'}
                alt="phonepay"
                src={phonepay}
                loading="lazy"
              />
            }
          />

          {WHDetails[BRAND_NAME.toLocaleLowerCase()].paytmNum ? (
            <Tab
              value={2}
              icon={
                <img
                  className={'payment-icon'}
                  alt="paytm"
                  src={paytm}
                  loading="lazy"
                />
              }
            />
          ) : null}
        </Tabs>

        <TabPanel value={tabValue} index={0}>
          <Bank />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <GPay />
        </TabPanel>

        <TabPanel value={tabValue} index={2}>
          <Paytm />
        </TabPanel>

        <TabPanel value={tabValue} index={3}>
          <PhonePay />
        </TabPanel>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {};
};

const mapDispatchToProps = (dispatch: Function) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Withdrawal);
